import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Paper,
  Stack,
  Box,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { sendSms } from "../../../api";
import Alert from "@mui/material/Alert";
import { makeStyles } from "@mui/styles";
import TrackEvents from "../../../api/amplitudeEvents";

const useStyles = makeStyles((theme) => ({
  activityDetailBox: {
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
    },
  },
}));

const Sms = ({ billing, id }) => {
  const classes = useStyles();
  const [phone, setPhone] = useState(billing ? billing.phone : "");
  const [name, setName] = useState(
    `${billing.first_name || ""} ${billing.last_name}`
  );
  const defaultMsg = `Dear ${name}. Please check your email, we have sent a mock for your order.
Thanks
Printyo Design Team 
**NO REPLY**`;

  const [msg, setMsg] = useState(defaultMsg);
  const msgReview = `Hi ${name},Hope your printed order arrived safely! We’d love to hear how it turned out. Your feedback helps us keep improving. Leave a quick review here: https://linktr.ee/printyoaus Thank you!”  
**NO REPLY**`;
  const [loading, setLoading] = useState(false);
  const [alertString, setAlertString] = useState("");
  const [alert, setAlert] = useState(false);
  const [responseSeverity, setResponseSeverity] = useState("");
  const userid = localStorage.getItem("auth_id");
  const [templates, setTemplates] = useState("template");
  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };
  const handleMsgChange = (e) => {
    setMsg(e.target.value);
  };

  const handleSelectTemplate = (e) => {
    setTemplates(e.target.value);
    if (e.target.value === "template") {
      setMsg(defaultMsg);
    } else if (e.target.value === "template1") {
      setMsg(msgReview);
    }
  };

  const handleSubmit = async () => {
    // if (templates === "template") {
    //   msg = msg;
    // } else if (templates === "template1") {
    //   msg = msgReview;
    // }
    if (!msg) {
      return;
    }
    var data = new FormData();
    data.append("smsnumber", phone);
    data.append("smsmessage", msg);
    data.append("userid", userid);
    try {
      setLoading(true);
      let result = await sendSms(id, data);
      //console.log("sms response", result);
      setLoading(false);
      setAlert(true);
      setAlertString("Message sent successfully");
      setResponseSeverity("success");
      // TrackEvents("SMS sent In Pending Order Activity", {
      //   orderId: id,
      // });
      TrackEvents(`${id}`, {
        process: "SMS sent Under Activity",
      });
      //setMsg("");
    } catch (error) {
      //console.log(error);
      setLoading(false);
      setAlert(true);
      setAlertString("Something went wrong while sending message to the user");
      setResponseSeverity("error");
    }
  };

  return (
    <Paper
      sx={{ p: 2, mt: 4, width: "70vw" }}
      className={classes.activityDetailBox}
    >
      {alert ? (
        <Alert
          severity={responseSeverity}
          sx={{
            margin: "10px 0 20px",
          }}
        >
          {alertString}
        </Alert>
      ) : null}

      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          sx={{
            color: "#3c434a",
            fontSize: "15px",
            lineHeight: "1.4em",
            fontWeight: "bold",
          }}
        >
          Send mail
        </Typography>
        <Stack direction="row" alignItems="center">
          <FormControl>
            <InputLabel id="demo-simple-select-label">Template</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={templates}
              label="Template"
              size="small"
              onChange={handleSelectTemplate}
            >
              <MenuItem value={"template"}>Mockup Template</MenuItem>
              <MenuItem value={"template1"}>Review Temaplate</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>

      <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
        <Typography
          sx={{
            mr: 2,
            color: "#3c434a",
            fontSize: "15px",
            lineHeight: "1.4em",
          }}
        >
          Phone number:
        </Typography>
        <TextField
          id="input-with-sx"
          size="small"
          type="number"
          variant="outlined"
          value={phone}
          onChange={handlePhoneChange}
        />
      </Box>
      <TextField
        id="filled-multiline-flexible"
        multiline
        margin="dense"
        rows={4}
        value={msg}
        onChange={handleMsgChange}
        fullWidth
      />
      <Box display="flex" alignItems="center" justifyContent="end" mt={2}>
        <Button
          variant="contained"
          endIcon={<SendIcon />}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Sending" : "send"}
        </Button>
      </Box>
    </Paper>
  );
};

export default Sms;
